import { useContext, useState } from 'react';
import { Grid, TextField, MenuItem, TablePagination } from '@material-ui/core';
import { Autocomplete } from '@material-ui/lab';
import { adminUsersContext } from '../AdminUsersContext';
import { applicationContext } from 'helpers/services/ApplicationContext';
import { UserType } from 'helpers/enums';
import { FilterContainer, SearchButton } from 'components';


let Filters = () => {

    let appService = useContext(applicationContext);
    let service = useContext(adminUsersContext);

    let [searchText, setSearchText] = useState('');

    return (
        <FilterContainer onSubmit={() => service.doSearch()}>
            <Grid item xs={2}>
                <TextField
                    variant="outlined"
                    label="Name"
                    value={service.search.name}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        name: e.target.value
                    })}
                />
            </Grid>
            <Grid item xs={2}>
                <Autocomplete
                    value={service.search.countryCode}
                    onChange={(event, newValue) => {
                        service.updateSearch({
                            ...service.search,
                            countryCode: newValue || ''
                        })
                    }}
                    inputValue={searchText}
                    onInputChange={(event, newInputValue) => {
                        setSearchText(newInputValue);
                    }}
                    getOptionLabel={(option) => appService.countries.find(x => x.key === option)?.value || 'Any'}
                    options={[
                        "",
                        ...appService.countries.map(x => x.key)
                    ]}
                    renderInput={(params) =>
                        <TextField {...params}
                            label="Country"
                            variant="outlined"
                        />
                    }
                />
            </Grid>
            <Grid item xs={2}>
                <TextField
                    select
                    variant="outlined"
                    label="User Type"
                    value={service.search.userType}
                    onChange={(e: any) => service.updateSearch({
                        ...service.search,
                        userType: e.target.value
                    })}
                >
                    <MenuItem value=''>Any</MenuItem>
                    <MenuItem value={UserType.Videndum}>{UserType.Videndum}</MenuItem>
                    <MenuItem value={UserType.External}>{UserType.External}</MenuItem>
                </TextField>
            </Grid>

            <Grid item xs>
                <SearchButton type="submit" />
            </Grid>

            <Grid item xs />

            <Grid item>
                <TablePagination
                    component="span"
                    rowsPerPageOptions={[service.search.pageSize]}
                    count={service.recordCount}
                    rowsPerPage={service.search.pageSize}
                    page={service.search.pageNr}
                    backIconButtonProps={{ 'aria-label': 'Previous Page' }}
                    nextIconButtonProps={{ 'aria-label': 'Next Page' }}
                    onPageChange={service.changePage}
                    labelDisplayedRows={({ page }) =>
                        <>
                            Total users:&nbsp;{service.recordCount} &nbsp;&middot;&nbsp;
                            <span>Page {page + 1} of {Math.ceil(service.recordCount / service.search.pageSize)}</span>
                        </>
                    }
                />
            </Grid>
        </FilterContainer>
    )
}

export default Filters;